var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('ui-input-text',{attrs:{"type":"text","value":_vm.query},on:{"update":_vm.onUpdateMethod}}),_c('img',{staticClass:"icon",attrs:{"src":require("./search.svg"),"alt":"Suchen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }